import { fetchOk } from '@atlassian/mpac-fetch-wrapper';

let request;

export default function getUserData(userUrl) {
  if (!request) {
    request = fetchOk(userUrl).then(response => response.json());
  }

  return request;
}
